import { z } from 'zod';
import { defineEndpoint } from '../define';

/** Open PRs of the product repo (same-repo heads only — forks can't be dispatched). */
export const GitPullSchema = z.object({
  number: z.number().int(),
  title: z.string(),
  headRef: z.string(),
  headSha: z.string(),
  /** ISO last-activity date. */
  updatedAt: z.string(),
});
export type GitPull = z.infer<typeof GitPullSchema>;

export const listGitPulls = defineEndpoint({
  method: 'GET',
  path: '/v1/release-products/:productId/git/pulls',
  params: z.object({ productId: z.string().uuid() }),
  query: z.object({}),
  body: z.undefined(),
  response: z.object({ data: z.array(GitPullSchema) }),
});
